<div class="page-header-container">
  <md-page-header [title]="serviceItem()?.name?.fi ?? ''" icon="product"></md-page-header>
  <md-info [item]="serviceItem()" [fields]="infoFields()" [pricingRouteLabel]="'INFO.GO_TO_PRICES'" [pricingType]="'service'"> </md-info>
  <md-audit-trail [auditTrail]="auditTrail()"></md-audit-trail>
</div>
